import React from 'react';
import { cn } from '@/lib/utils';

const spinnerVariants = {
  small: 'h-5 w-5 border-2',
  medium: 'h-8 w-8 border-t-2 border-b-2',
  large: 'h-16 w-16 border-t-4 border-b-4',
};

interface SpinnerProps {
  size?: keyof typeof spinnerVariants;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'medium', className }) => {
  return (
    <div
      className={cn(
        'animate-spin rounded-full border-solid border-sauna-orange',
        spinnerVariants[size],
        className
      )}
    ></div>
  );
}; 